import { combineReducers } from 'redux';
import queryStringReducer from '../mle/query-string-reducer';
import initMleReducer from '../mle/init-mle-reducer';
import activityReducer from '../activity/activity-reducer';
import modalReducer from '../modal/modal-reducer';
import errorHandlingReducer from '../error-handling/error-handling-reducer';
import userReducer from '../user/user-reducer';
import spinnerReducer from '../mle/spinner-reducer';
import timeOnlineReducer from '../mle/time-online-reducer';
import conquestReducer from '../conquest/conquest.reducer';

const CombinedReducers = combineReducers({
  queryStringReducer,
  initMleReducer,
  activityReducer,
  modalReducer,
  errorHandlingReducer,
  userReducer,
  spinnerReducer,
  timeOnlineReducer,
  conquestReducer
});

export default CombinedReducers;
